import { updateOrderSnapshot } from '@/entities/order';
import { Alert, type AlertProps } from '@/shared/components/Alert';
import { DrawerBottomFixed, DrawerButton } from '@/shared/components/Drawer';
import { useAsyncFn } from '@/shared/lib/hooks';

type OutdatedItemPricesModalProps = AlertProps & {
    orderId: string;
    storeSlug: string;
    signature: string;
};

export const OutdatedItemPricesModal = (props: OutdatedItemPricesModalProps) => {
    const { signature, orderId, storeSlug, ...other } = props;
    const [{ loading, error }, onUpdateSnapshot] = useAsyncFn(async () => {
        await updateOrderSnapshot({ order_id: orderId, signature, store_slug: storeSlug });
        window.location.reload();
    }, [signature, orderId]);

    return (
        <Alert
            {...other}
            title="Цены изменились"
            description="Пока вас не было, цены на некоторые товары изменились. Обновите страницу, чтобы увидеть актуальные цены"
            button={
                <DrawerBottomFixed>
                    <DrawerButton isDisabled={loading} onClick={onUpdateSnapshot}>
                        Обновить
                    </DrawerButton>
                </DrawerBottomFixed>
            }
            errorText={error && 'Не удалось обновить цены. Попробуйте позже'}
        />
    );
};
